import { connect } from 'react-redux';
import createImmutableSelector from 'utils/immutable-selector';
import {
  projectsSelector,
  currentProjectSelector,
  currentProjectIdSelector,
} from 'modules/user/selectors';

import ProgressWindow from './ProgressWindow';

const mapStateToProps = createImmutableSelector(
  currentProjectSelector,
  currentProjectIdSelector,
  projectsSelector,
  (currentProject, currentProjectId, projects) => ({
    currentProject,
    currentProjectId,
    projects,
  })
);

const mapDispatchToProps = null;

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(ProgressWindow);
